import { createFileRoute } from '@tanstack/react-router'

import { TermsOfServiceSettingsPage } from '@/pages/settings/terms-of-service/TermsOfServiceSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/terms-of-service/',
)({
  component: TermsOfServiceSettingsPage,
})
